/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FormRiskEntry } from '../../models/form-risk-entry';
import { FormRiskEntryCreateDto } from '../../models/form-risk-entry-create-dto';

export interface Create$Params {
  formId: string;
  body: FormRiskEntryCreateDto;
}

export function create(
  http: HttpClient,
  rootUrl: string,
  params: Create$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<FormRiskEntry>> {
  const rb = new RequestBuilder(rootUrl, create.PATH, 'post');
  if (params) {
    rb.path('formId', params.formId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FormRiskEntry>;
    })
  );
}

create.PATH = '/forms/{formId}/risk-entry';
